import React from 'react';

import { Container } from './elements';
import { getNextEpisodeDate } from './getNextEpisodeDate';
import { getSeasonEpisoded } from './getSeasonEpisoded';
import { NextEpisodeCard } from './NextEpisodeCard';
import { SeriesEpisodeCard } from '../../SeriesEpisodeCard';
import { useSeasonsState } from '../SeasonsProvider';

export const SeasonEpisodes: React.FC = () => {
  const { activeSeason, loading } = useSeasonsState();
  const episodes = getSeasonEpisoded(activeSeason);
  const nextEpisodeDate = getNextEpisodeDate(activeSeason);
  return (
    <Container>
      {loading
        ? new Array(3)
            .fill(null)
            .map((...params) => <SeriesEpisodeCard.Placeholder key={params[1]} />)
        : episodes.map(item => <SeriesEpisodeCard key={item.id} details={item} />)}
      <NextEpisodeCard nextEpisodeDate={nextEpisodeDate} />
    </Container>
  );
};
